import { AxiosInstance } from 'axios';

import { axios } from '../../../../api/axios-instance';
import { purchasesEndpoints } from '../../../../constants/endpoints';
import { AddNewPurchaseBody, GetAllPurchasesResponse } from '../../schemas/purchase.schema';

class PurchasesApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  addNewPurchase = async (input: AddNewPurchaseBody): Promise<AddNewPurchaseBody> =>
    this.#requestInstance.post(purchasesEndpoints.purchases, input);

  getAllPurchases = async (orderId: number): Promise<GetAllPurchasesResponse> =>
    this.#requestInstance.get(purchasesEndpoints.purchasesId(orderId));
}

export const purchasesApi = new PurchasesApi(axios);
